
import React from "react";
import { Button } from "@/components/ui/button";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger
} from "@/components/ui/dropdown-menu";
import { Edit, Trash2 } from "lucide-react";

interface BulkActionsMenuProps {
  selectedCount: number;
  onBulkDelete: () => void;
  onBulkEdit: () => void;
}

export const BulkActionsMenu: React.FC<BulkActionsMenuProps> = ({
  selectedCount,
  onBulkDelete,
  onBulkEdit
}) => {
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button variant="outline" size="sm">
          Bulk actions ({selectedCount})
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="w-56">
        <DropdownMenuItem onClick={onBulkEdit} className="cursor-pointer">
          <Edit className="mr-2 h-4 w-4" />
          <span>Edit selected</span>
        </DropdownMenuItem>
        <DropdownMenuItem 
          onClick={onBulkDelete} 
          className="cursor-pointer text-destructive focus:text-destructive"
        >
          <Trash2 className="mr-2 h-4 w-4" />
          <span>Delete selected</span>
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
};
